const cookie = document.cookie;
if (cookie.includes("currentUser") == false) {
    const credentials = { credentials: "include" };
    fetch("https://moa.medonegroup.com/Services/v1/Users/Current", credentials)
        .then((res) => {
            if (res.ok == false) {
                location.href = "https://moa.medonegroup.com/Login";
            }
            return res;
        })
        .then((res) => res.json())
        .then((data) => {
            let email = data["Email"];
            document.cookie = "currentUser=" + email + ";SameSite=None;Secure";
        })
        .catch((err) => {
            console.log("failed to authenticate user");
        });
}
